import { Dispatch, createContext, useContext, useMemo, useState } from 'react';

import { TermsPolicy } from 'pages/public/components/common';
import { MFA_METHOD } from 'utils/constants';
import { cn } from 'utils/helpers';
import { MFA as _MFA } from 'utils/types';
import { useLogin } from 'pages/public/hooks';

import LoginForm from '../../forms/LoginForm';
import PublicWrapper from '../PublicWrapper';
import PasswordExpired from './PasswordExpired';
import MFA from './MFA';

interface CONTEXT {
  method: MFA_METHOD | null;
  setMethod: Dispatch<React.SetStateAction<MFA_METHOD | null>>;
  mfa: _MFA | null;
  setMfa: Dispatch<React.SetStateAction<_MFA | null>>;
}

export const LoginContext = createContext<CONTEXT>({} as CONTEXT);
// eslint-disable-next-line react-refresh/only-export-components
export const useLoginContext = () => useContext(LoginContext);

const Login = () => {
  const [method, setMethod] = useState<MFA_METHOD | null>(null);
  const [mfa, setMfa] = useState<_MFA | null>(null);

  const { mutate: login, isLoading, data } = useLogin();

  const _value = useMemo(
    () => ({
      method,
      setMethod,
      mfa,
      setMfa,
    }),
    [mfa, setMfa, method, setMethod],
  );

  const renderForm = useMemo(() => {
    if (!data) return <LoginForm isLoading={isLoading} onSubmitForm={login} />;

    if (data?.data.passwordExpired && !data?.data?.loginValidated)
      return <PasswordExpired />;

    if (!data?.data?.loginValidated) return <MFA {...data?.data} />;
  }, [data, isLoading, login]);

  return (
    <PublicWrapper
      className={cn(
        'flex items-center md:justify-center flex-col',
        'px-6 py-10 md:py-0',
      )}
    >
      <LoginContext.Provider value={_value}>
        {renderForm}
        <TermsPolicy />
      </LoginContext.Provider>
    </PublicWrapper>
  );
};

export default Login;
